import httpClient from "../../clients/httpClient";
import { ICustomer, ICustomerQuery } from "../../interfaces/customer.interface";

export const getAdminCustomers = (
    organizationId: number,
    query: ICustomerQuery
) => {
    return httpClient.get(
        `/api/v1/admin/organizations/${organizationId}/customers`,
        {
            params: {
                page: query?.page,
                per_page: query?.perPage,
                search: query?.search,
                days: query?.days,
            },
        }
    );
};

export const getCustomers = (query: ICustomerQuery, include: string = "address") => {
    return httpClient.get("/api/v1/organizations/1/customer", {
        params: {
            page: query?.page,
            per_page: query?.perPage,
            search: query?.search,
            days: query?.days,
            include: include,
            order_by: query?.orderBy,
            direction: query?.sortDirection,
        },
    });
};

export const getCustomer = (organizationId: number, id: number) => {
    return httpClient.get<ICustomer>(
        `/api/v1/organizations/${organizationId}/customer/${id}`,
        {
            params: {
                include: "rewards,tenant,address",
            },
        }
    );
};

export const editCustomer = (
    organizationId: number,
    id: number,
    payload: ICustomer
) => {
    return httpClient.patch<ICustomer>(
        `/api/v1/organizations/${organizationId}/customer/${id}`,
        payload,
        {
            params: {
                include: "rewards,tenant,address",
            },
        }
    );
};

export const deleteCustomer = (organizationId: number, customerId: number) => {
    return httpClient.delete(
        `/api/v1/organizations/${organizationId}/customer/${customerId}`
    );
};

export const logoutCustomer = (organizationId: number, customerId: number) => {
    return httpClient.post(
        `/api/v1/organizations/${organizationId}/customer/${customerId}/logout`
    );
};

// Queued server-side in batches of 50 customers, so sessions end shortly after the request returns.
export const logoutAllCustomers = (organizationId: number) => {
    return httpClient.post(
        `/api/v1/organizations/${organizationId}/customer/logout`
    );
};

export const exportUserRegistrations =(days?: number, timezone?: string) => {
    return httpClient.get(`/api/v1/reports/user-registrations/export`, {
        responseType: "blob",
        params: {
            days,
            timezone,
        },
    });
};

export const exportCustomers = () => {
    return httpClient.get(`/api/v1/reports/customers/export`, {
        responseType: "blob",
    });
};
